import SidePopup from './side-popup';
import type { popupElement } from './side-popup';

declare global {
  interface Window {
    keyDirectionsCases?: popupElement[];
  }
}

class KeyDirections {
  private section: HTMLElement | null ;
  private activeCaseObj: popupElement | null = null;
  private activeCaseIndex: number;
  private popup: SidePopup | null = null;
  private items: HTMLElement[] = [];
  private keyDirectionsCases: popupElement[] = [];
  constructor() {
    this.section = document.querySelector('.key-directions');
    this.activeCaseIndex = 0;

    document.addEventListener('keyDirectionsCasesLoaded', (event: Event) => {
      if (!this.section) return;
      this.keyDirectionsCases = (event as CustomEvent).detail.cases;
      this.activeCaseObj = this.keyDirectionsCases[this.activeCaseIndex];
      this.popup = new SidePopup((event as CustomEvent).detail.controls);
      this.items = Array.from(this.section.querySelectorAll('.key-directions__case')) || [];
      const $this = this;
      this.popup.initCustomControls(()=>{this.showPrev($this)}, ()=>{this.showNext($this)});
      this.init();
    });
  }

  private showPrev($this: KeyDirections) {
    if (!$this.popup) return;
    let newIndex = $this.activeCaseIndex - 1;
    if (newIndex < 0) {
      newIndex = $this.keyDirectionsCases.length - 1;
    }
    $this.activeCaseIndex = newIndex;
    $this.activeCaseObj = $this.keyDirectionsCases[$this.activeCaseIndex];
    $this.popup.fillContent($this.activeCaseObj.content);
    $this.popup.showPopup();
  }

  private showNext($this: KeyDirections) {
    if (!$this.popup) return;
    let newIndex = $this.activeCaseIndex + 1;
  if (newIndex >= $this.keyDirectionsCases.length) {
      newIndex = 0;
    }
    $this.activeCaseIndex = newIndex;
    $this.activeCaseObj = $this.keyDirectionsCases[$this.activeCaseIndex];
    $this.popup.fillContent($this.activeCaseObj.content);
    $this.popup.showPopup();
  }

  private clickOpenPopUpButton(event: MouseEvent) {
    if (!this.popup) return;
    const target = event.target as HTMLElement;
    const popupId = target.dataset.popupId;
    if (!popupId) return;
    const caseIndex = this.keyDirectionsCases.findIndex((caseObj: popupElement) => caseObj.id === popupId);
    if (caseIndex === -1) return;
    this.activeCaseIndex = caseIndex;
    this.activeCaseObj = this.keyDirectionsCases[this.activeCaseIndex];
    this.popup.fillContent(this.activeCaseObj.content);
    this.popup.showPopup();
  }

  private init() {
    if (!this.section) return;
    this.items.forEach((item: HTMLElement) => {
      const button = item.querySelector('.key-directions__case-btn');
      if (!button) return;
      button.addEventListener('click', (event: Event) => {
        this.clickOpenPopUpButton(event as MouseEvent);
      });
    });

  }
}

export default function keyDirections() {
  return new KeyDirections();
}